import { render } from "./GemMechanism07.vue?vue&type=template&id=7531caf5&scoped=true"
const script = {}

import "./GemMechanism07.vue?vue&type=style&index=0&id=7531caf5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7531caf5"]])

export default __exports__